//import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

import { lazy, Suspense } from "react";

// to can use global variables
// eslint gives errors
//import axios from 'axios';
//window.axios = axios;

// https://www.npmjs.com/package/react-error-boundary
import { ErrorBoundary } from "react-error-boundary";
const Error = lazy(() => import('/src/pages/Error'));
import { sendLogs } from '@/utils/Logs';

//import { BrowserRouter } from 'react-router-dom';

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

//import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguage, setLanguage } from "@/utils/Language";

// split translations to avoid retranslation every time we develop new code

// ENGLISH
import en_1 from "./translations/en/global.json";
import en_2 from "./translations/en/global2.json";
const translation_en = { ...en_1, ...en_2 };

// SPANISH
import es_1 from "./translations/es/global.json";
import es_2 from "./translations/es/global2.json";
const translation_es = { ...es_1, ...es_2 };

// CATALÀ
import ca_1 from "./translations/ca/global.json";
import ca_2 from "./translations/ca/global2.json";
const translation_ca = { ...ca_1, ...ca_2 };

const defaultLanguage = 'es';

var language = getLanguage();

if(!language || language.length === 0){
    language = defaultLanguage;
    setLanguage(language);
}

i18next
    //.use(LanguageDetector)
    .init({
        interpolation: { escapeValue: false },  // React already does escaping
        lng: language,                              // language to use
        resources: {
            en: {
                // 'global' is our custom namespace
                global: translation_en
            },
            es: {
                global: translation_es
            },
            ca: {
                global: translation_ca
            }
        },
});

// what to do if any error
const fallback = ({error /*,resetErrorBoundary*/ }) => {

    // if localhost, print error
    if(window.location.href.includes('localhost') || window.location.href.includes('127.0')){
        console.log(error);
    }

    // Call resetErrorBoundary() to reset the error boundary and retry the render.    
    return (
        <Suspense>
            <Error/>
        </Suspense>
    );
}

// log the error
const logError = (error,info) => {  
    sendLogs(language,error.message,info?.componentStack);
};

const handleLanguage = (iso) => {  
    
    // change on app
    i18next.changeLanguage(iso); 

    // save on local storage
    setLanguage(iso);

    // necessary to refresh because on tables the headers are not translated    
    // or the renders because they don't depend on any variable
    window.location.reload();

};

createRoot(document.getElementById('root')).render(
    //<StrictMode> if commented, avoiding calling useEffect twice
    //      <BrowserRouter>
                <ErrorBoundary FallbackComponent={fallback} onError={logError}>
                    <I18nextProvider i18n={i18next}>
                        <App handleLanguage={handleLanguage}/>
                    </I18nextProvider>
                </ErrorBoundary>
    //      </BrowserRouter>
    //</StrictMode>,
)
